import { ILastState } from '../../state/types';
import { makeManagedSourceSetFetch } from './_shared/fetchMakers';
import { normalizeSingleEntity } from './_shared/normalizers';
import { makeTasksUrl } from './_shared/urlMakers';

export const fetchTasks = makeManagedSourceSetFetch<ILastState[]>(
    makeTasksUrl,
    normalizeSingleEntity
);
